(() => {
  const initializeMediaFrame = (frame) => {
    if (!frame || frame.dataset.psMediaReady === "true") return;
    frame.dataset.psMediaReady = "true";

    const loader = frame.querySelector("[data-ps-model-loader]");
    const image = frame.querySelector("img:not([data-ps-loader-icon])");
    const viewer = frame.querySelector("model-viewer");

    const showLoader = () => {
      if (!loader || viewer?.loaded === true) return;
      loader.hidden = false;
      frame.classList.add("is-media-loading");
      frame.classList.remove("is-media-loaded");
    };

    const hideLoader = () => {
      if (loader) loader.hidden = true;
      frame.classList.remove("is-media-loading");
      frame.classList.add("is-media-loaded");
    };

    if (image) {
      if (image.complete) {
        hideLoader();
      } else {
        image.addEventListener("load", hideLoader, { once: true });
        image.addEventListener("error", hideLoader, { once: true });
      }
    }

    if (!viewer) return;

    const posterButton = frame.querySelector(
      ".shopify-model-viewer-ui__button--poster"
    );
    posterButton?.addEventListener("click", showLoader);
    viewer.addEventListener("shopify_model_viewer_ui_toggle_play", showLoader);
    viewer.addEventListener("poster-dismissed", showLoader);
    viewer.addEventListener("load", hideLoader);
    viewer.addEventListener("error", hideLoader);
    viewer.addEventListener("progress", (event) => {
      const progress = Number(event.detail?.totalProgress || 0);
      if (progress > 0 && progress < 1) showLoader();
      if (progress >= 1) hideLoader();
    });

    if (viewer.loaded === true) hideLoader();
  };

  const initializeProductSystem = (root) => {
    if (!root || root.dataset.psReady === "true") return;
    root.dataset.psReady = "true";

    const variantsNode = root.querySelector("[data-ps-variants]");
    const variants = variantsNode
      ? JSON.parse(variantsNode.textContent || "[]")
      : [];
    const optionInputs = [...root.querySelectorAll("[data-ps-option]")];
    const variantInput = root.querySelector("[data-ps-variant]");
    const price = root.querySelector("[data-ps-price]");
    const sku = root.querySelector("[data-ps-sku]");
    const releaseState = root.querySelector("[data-ps-release-state]");
    const submit = root.querySelector("[data-ps-submit]");
    const inquiry = root.querySelector("[data-ps-inquiry]");
    const purchaseLocked = root.dataset.psPurchaseLocked === "true";
    const currency = window.Shopify?.currency?.active || "USD";
    const locale = document.documentElement.lang || "en";

    const formatMoney = (cents) =>
      new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
      }).format(cents / 100);

    const syncVariant = () => {
      if (!variants.length) return;

      const selected = optionInputs.map((input) => input.value);
      const variant = optionInputs.length
        ? variants.find((candidate) =>
            candidate.options.every(
              (option, index) => option === selected[index]
            )
          )
        : variants[0];

      if (!variant) {
        if (submit) submit.hidden = true;
        if (inquiry) inquiry.hidden = false;
        if (releaseState) releaseState.textContent = "CONFIGURATION REVIEW";
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (price) {
        price.textContent =
          purchaseLocked
            ? "PRICING REVIEW"
            : variant.price === 0
              ? "PROJECT PRICING"
              : formatMoney(variant.price);
      }
      if (sku) {
        sku.textContent = variant.sku || "Assigned at release";
      }

      const isReleased =
        !purchaseLocked && variant.available && variant.price > 0;
      if (submit) {
        submit.hidden = !isReleased;
        submit.disabled = !isReleased;
      }
      if (inquiry) {
        inquiry.hidden = isReleased;
        const target = new URL(
          inquiry.dataset.baseHref || "/pages/contact",
          window.location.origin
        );
        target.searchParams.set("product", root.dataset.productSystem || "exo");
        target.searchParams.set("handle", window.location.pathname.split("/").pop());
        target.searchParams.set("variant", variant.id);
        inquiry.href = `${target.pathname}${target.search}`;
      }
      if (releaseState) {
        releaseState.textContent = purchaseLocked
          ? "CONFIGURATION REVIEW"
          : isReleased
            ? "RELEASED"
            : variant.available
              ? "CONFIGURE + QUOTE"
              : "INQUIRY";
      }
    };

    optionInputs.forEach((input) =>
      input.addEventListener("change", syncVariant)
    );
    syncVariant();
  };

  const initializeAll = (scope = document) => {
    scope
      .querySelectorAll("[data-ps-media-frame]")
      .forEach(initializeMediaFrame);
    scope
      .querySelectorAll("[data-ps-product]")
      .forEach(initializeProductSystem);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeAll(event.target);
  });
})();
